import { render, staticRenderFns } from "./MessageEdit.vue?vue&type=template&id=ebe8f0e0&scoped=true&"
import script from "./MessageEdit.vue?vue&type=script&lang=js&"
export * from "./MessageEdit.vue?vue&type=script&lang=js&"
import style0 from "./MessageEdit.vue?vue&type=style&index=0&id=ebe8f0e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe8f0e0",
  null
  
)

export default component.exports